export const SPECIES = [
  {
    labelTc: '葉菜類',
    labelSc: '叶菜类',
    labelEn: 'Leaf',
    filterKey: '葉菜',
  },
  {
    labelTc: '瓜類',
    labelSc: '瓜类',
    labelEn: 'Gourd',
    filterKey: '瓜',
  },
  {
    labelTc: '茄果類',
    labelSc: '茄果类',
    labelEn: 'Solanaceae',
    filterKey: '茄果',
  },
  {
    labelTc: '豆類',
    labelSc: '豆类',
    labelEn: 'Pea & Bean',
    filterKey: '豆',
  },
  {
    labelTc: '根莖',
    labelSc: '根茎',
    labelEn: 'Root & Stem',
    filterKey: '根莖',
  },
  {
    labelTc: '水果類',
    labelSc: '水果类',
    labelEn: 'Fruit',
    filterKey: '水果',
  },
  {
    labelTc: '香草類',
    labelSc: '香草类',
    labelEn: 'Herb',
    filterKey: '香草',
  },
  {
    labelTc: '水稻類',
    labelSc: '水稻类',
    labelEn: 'Paddy',
    filterKey: '水稻',
  },
  {
    labelTc: '其他',
    labelSc: '其他',
    labelEn: 'Others',
    filterKey: '其他',
  },
];
